import { render, staticRenderFns } from "./CourseRoom.vue?vue&type=template&id=080435a2&"
import script from "./CourseRoom.vue?vue&type=script&lang=js&"
export * from "./CourseRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports